import { Validators } from '@angular/forms';

export const SSOFields = [
  {
    type: 'input',
    label: 'Email',
    name: 'email',
    placeholder: 'Email',
    icon: 'user',
    validation: [Validators.required],
  },
  {
    label: 'Continue',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
    sso: true,
  },
];
